export const competitorProduct = {
    getList,
    getCompetitorList,
    addCompetitorProduct,
    addCompetitorProductCombo,
    prepareCompetitorProductBatch,
    createCompetitorProductBatch,
    getPartInfo
};

async function addCompetitorProduct(
    date,
    part_number,
    brand,
    name,
    price,
    competitor
) {
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include',
        body: JSON.stringify({
            date,
            part_number,
            brand,
            name,
            price,
            competitor
        })
    };

    return await fetch('${process.env.VUE_APP_API_URL}/api/competitor-products/create', requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result;
        });
}

async function prepareCompetitorProductBatch(file) {
    let data = new FormData()
    data.append('file', file)

    const requestOptions = {
        method: 'POST',
        credentials: 'include',
        body: data
    };

    return await fetch('${process.env.VUE_APP_API_URL}/api/competitor-products/prepare-batch', requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result.data;
        });
}

async function createCompetitorProductBatch(products) {
    const requestOptions = {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            products
        })
    };

    return await fetch('${process.env.VUE_APP_API_URL}/api/competitor-products/create-batch', requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result.data;
        });
}

async function addCompetitorProductCombo(
    price,
    records
) {
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include',
        body: JSON.stringify({
            price,
            records
        })
    };

    return await fetch('${process.env.VUE_APP_API_URL}/api/competitor-products/create-combo', requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result;
        });
}

async function getList(
    query,
    perPage,
    currentPage
) {
    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include'
    };

    let limit = perPage;
    let offset = 0;

    if (currentPage > 1) {
        offset = perPage * currentPage - 1;
    }

    let url = `${process.env.VUE_APP_API_URL}/api/competitor-products?limit=${limit}&offset=${offset}`;

    if (query) {
        url += '&query=' + query;
    }

    return await fetch(url, requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result;
        });
}

async function getCompetitorList() {
    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include'
    };

    return await fetch('${process.env.VUE_APP_API_URL}/api/competitors', requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result;
        });
}

async function getPartInfo(partNumber) {
    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include'
    };

    return await fetch(`${process.env.VUE_APP_API_URL}/api/part-info?part_number=${partNumber}`, requestOptions)
        .then(handleResponse)
        .then(async result => {
            return result;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.error) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}